import React from 'react';
import { Eye, EyeOff, AlertCircle } from 'lucide-react';

const ConfigInput = ({ label, value, onChange, type = 'text', suffix, description, min, max, error }) => {
    const [showPassword, setShowPassword] = React.useState(false);
    const [localError, setLocalError] = React.useState('');

    const inputType = type === 'password' && showPassword ? 'text' : type;

    // Handle email and url types as text inputs with validation
    const actualType = (type === 'email' || type === 'url') ? 'text' : inputType;

    const validateInput = (val) => {
        setLocalError('');

        if (type === 'email' && val) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(val)) {
                setLocalError('Please enter a valid email address');
            }
        }

        if (type === 'url' && val) {
            try {
                new URL(val);
            } catch {
                setLocalError('Please enter a valid URL');
            }
        }

        if (type === 'number') {
            const numVal = parseFloat(val);
            if (min !== undefined && numVal < min) {
                setLocalError(`Minimum value is ${min}`);
            }
            if (max !== undefined && numVal > max) {
                setLocalError(`Maximum value is ${max}`);
            }
        }

        onChange(val);
    };

    const displayError = error || localError;

    return (
        <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
                {label}
                {type === 'password' && !value && (
                    <span className="text-xs text-gray-500 ml-2">(Required)</span>
                )}
            </label>
            <div className="relative">
                <input
                    type={actualType}
                    value={value || ''}
                    onChange={(e) => validateInput(e.target.value)}
                    min={min}
                    max={max}
                    className={` outline-none w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${displayError ? 'border-red-300 focus:ring-red-500' : 'border-gray-300'
                        } ${type === 'password' ? 'pr-10' : suffix ? 'pr-16' : ''
                        }`}
                    placeholder={
                        type === 'email' ? 'email@example.com' :
                            type === 'url' ? 'https://example.com' :
                                type === 'password' && !value ? '••••••••' :
                                    type === 'number' && min !== undefined && max !== undefined ? `${min} - ${max}` :
                                        ''
                    }
                />
                {type === 'password' && (
                    <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 transition-colors"
                    >
                        {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                    </button>
                )}
                {suffix && type !== 'password' && (
                    <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-sm text-gray-500 pointer-events-none bg-white px-1">
                        {suffix}
                    </span>
                )}
                {displayError && (
                    <div className="absolute right-2 top-1/2 transform -translate-y-1/2 text-red-500">
                        <AlertCircle className="w-4 h-4" />
                    </div>
                )}
            </div>
            {displayError && (
                <p className="mt-1 text-sm text-red-600 flex items-center gap-1">
                    <span>{displayError}</span>
                </p>
            )}
            {description && !displayError && (
                <p className="mt-1 mb-4 text-xs text-gray-400">{description}</p>
            )}
        </div>
    );
};

export default ConfigInput; 